import { render, staticRenderFns } from "./SearchTipsModal.vue?vue&type=template&id=29780937&scoped=true"
var script = {}
import style0 from "./SearchTipsModal.vue?vue&type=style&index=0&id=29780937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29780937",
  null
  
)

export default component.exports